import axios from "axios";
import AuthService from "../login/auth.service";
import { creditos, cuentas } from "../../components/generico/utils/UrlAPI";


class PrestamoInmediatoService {

  /**
   * @author mbareiro
   * Obtiene las sucursales para el desembolso
   * @returns 
   */
  async getSucursalDesembolso() {
    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/sucursales?canal=WEB',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene los plazos
   * @returns 
   */
   async getPlazos() {
    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/plazos?canal=WEB',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene la linea de crédito preaprobado
   * @returns 
   */
   async getLineaCredito() {
    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/verificar-linea-credito?canal=WEB&moneda=GS&tipoLinea=LCP',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene si el socio está en mora en algún credito como titular o codeudor
   * @returns 
   */
   async getMoraCredito() {

    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/consultar-mora-credito?canal=WEB',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene el monto de la cuota
   * @returns 
   */
   async getMontoCuota(monto, plazo) {

    var _url = creditos + "creditos-preaprobados/calcular-cuota?canal=WEB&idModalidad=731&tipoGarantia=1&tipoCalculo=F&tipoCredito=P&moneda=GS";
    _url = _url + "&plazo=" + plazo + "&monto=" + monto

    var config = {
      method: "get",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene la mora en aporte y solidaridad del socio y conyuge
   * @returns 
   */
   async getMoraCompromiso(monto) {

    var _url = creditos + "creditos-preaprobados/consultar-mora-compromisos?canal=WEB&idModalidad=765&moneda=GS";
    _url = _url + "&monto=" + monto

    var config = {
      method: "get",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Confirma la solicitud de prestamo preaprobado
   * @param {*} monto 
   * @param {*} plazo 
   * @param {*} nroSucursal 
   * @param {*} moneda 
   * @returns 
   */
  async confirmarSolicitud(monto, plazo, nroSucursal, moneda) {

    var data = JSON.stringify({
      canal: "WEB",
      plazoOperacion: plazo,
      idModalidad: "765",
      monto: monto,
      numeroSucursal: nroSucursal,
      moneda: moneda,
      tipoGarantia: "1",
      tipoCalculo: "F",
      tipoCredito: "P",
      tipoLinea: "LCP"
    });
    
    var config = {
      method: "post",
      url: creditos + 'creditos-preaprobados/solicitar',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    
    return await axios(config);
  }
  async getCuentas(tipoCuenta) {
    var data = JSON.stringify({
      canal: "WEB",
      tipo: tipoCuenta,
      estado: null,
      modalidad: null,
      moneda: null,
      tipoCuenta: null
    });

    var config = {
      method: "get",
     // url: cuentasSocio + "socio-cuenta/cuentas-individuales",
     // url:"https://run.mocky.io/v3/9d7b6be5-189f-4322-a13b-22a4ad6cbaa7",
      url: cuentas +  "socio-cuenta/cuentas-individuales",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data
    };

    return await axios(config);
  }

  async obtenerReporte(data){
    let config = {
      method : 'post',
      url: `${creditos}creditos-preaprobados/obtenerContrato`,
      responseType:'blob',
      headers : {
        'Authorization' : `Bearer ${AuthService.getCurrentToken()}`
      },
      data : data
    };
    return await axios(config);
  }
}





export default new PrestamoInmediatoService();